<template>
  <div>    
     <!-- :style="cssVars" -->
      <el-upload :action="action" :list-type="listType"   class="upload-demo"   :style="cssVars"
          multiple
          :on-preview="handlePictureCardPreview" 
          :on-remove="handleRemove" 
           :limit="limit"
           :accept="accept"
          :file-list="fileList"
          :on-exceed="handleExceed"
           :on-success="handleSuccess"
           
          >
          <i class="el-icon-plus"></i>
      </el-upload>
     <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>  
    
  </div>
</template>
<script>
  
// 导出模块
export default {
  props:{
      limit: { type: Number, default: 6 },
      // text/picture/picture-card
      listType:{type:String,default:'picture-card'},
      // accept  指可上传的文件格式
      accept:{type:String,default:'image/png, image/jpeg,image/jpg'},
      list:{type:Array,default:()=>[]},
      index:{type:[Number,String],default:0},
      imgstr:{type:String,default:null},
      size:{type:String,default:'sm'},
      width:{type:[Number,String],default:'200'},
      cateName: { type: String, default: '' },
      type: { type: String, default: 'img' },
      csssize:{ type: [String,Number], default: '148px'},
   
  },
  data() {
    //数据  
    return {
      fileList:[],
      uploadData:[],
      dialogImageUrl: '',
      dialogVisible: false,
      action:localStorage.getItem("upload"),
      actionupload:false

    };
  },
  computed: {
    
    // 内容类名
    contClass() {
     
    let  contClass =this.size 
     console.log(this.size)
      return contClass
    },
    cssVars(){
      return {"--csssize": this.csssize}
    },
   
  },
  watch:{
    list(){
        this.fileList= this.changeFileList(this.list)
        console.log(this.fileList)
      },
    imgstr(){
      if(!this.actionupload){
        this.fileList= this.changeFileList(this.imgstr.split(","))
      }
    
    },
 },

  methods: {
      clear(){
        this.fileList = []
      },
      handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
      //  图片上传
      handleRemove(file, fileList) {
        this.actionupload = true
      this.uploadData = fileList
      this.$emit('click',this.ChangeuploadData(fileList),this.cateName,this.index)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(response, file, fileList) {
      this.actionupload = true
        console.log('handleSuccess261',response,file,fileList)
      this.uploadData = fileList
      this.$emit('click',this.ChangeuploadData(fileList),this.cateName,this.index)
    
    },
    ChangeuploadData(data){
      let emitArr= []
      console.log(data)
      if(data.length){
         data.forEach((item)=>{
           emitArr.push(item.response.data)
         })
      }
      if(emitArr.length){
         return emitArr.join(",")
      }else{
        return ""
      }
     
     
    },
    changeFileList(data){
      let arr = []
      console.log('changeFileList',data)
        data.forEach(item=>{
           arr.push({name: "list-empy-member.png", 
           response: {data:item, message: "文件上传成功", status: 2000}, 
           url: item,
            })
         })
         return arr
    }
  },
  // 创建前状态(里面是操作)
  beforeCreate() { },
  // 创建完毕状态(里面是操作)
  created() { 
  
    if(this.list.length){ 
       
        this.fileList= this.changeFileList(this.list)
    }
   if(this.imgstr){
     this.fileList= this.changeFileList(this.imgstr.split(","))
   }
   
  },
  // 挂载前状态(里面是操作)
  beforeMount() { },
  // 挂载结束状态(里面是操作)
  mounted() { },
  // 更新前状态(里面是操作)
  beforeUpdate() { },
  // 更新完成状态(里面是操作)
  updated() { },
  // 销毁前状态(里面是操作)
  beforeDestroy() { },
  // 销毁完成状态(里面是操作)
  destroyed() { }
};
</script>

<style >
.sm .el-upload-list--picture-card .el-upload-list__item {
width: 60px !important;
height: 60px !important;
}
.sm  .el-upload--picture-card{
width: 60px !important;
height: 60px !important;
line-height:60px !important;
}
.base .el-upload-list--picture-card .el-upload-list__item {
width: 100px !important;
height: 100px !important;
}
.base  .el-upload--picture-card{
width: 100px !important;
height: 100px !important;
line-height:100px !important;
}
.large .el-upload-list--picture-card .el-upload-list__item {
width: 130px !important;
height: 130px !important;
}
.large  .el-upload--picture-card{
width: 130px !important;
height: 130px !important;
line-height:130px !important;
}
.el-upload-list--picture-card .el-upload-list__item {
width: var(--csssize) !important;
height: var(--csssize) !important;
}
.el-upload--picture-card{
width: var(--csssize) !important;
height:var(--csssize) !important;
line-height:var(--csssize) !important;
}
</style>